var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2503 10.7499H28.667C28.667 6.79034 25.4599 3.58325 21.5003 3.58325C17.5407 3.58325 14.3337 6.79034 14.3337 10.7499H10.7503C8.77949 10.7499 7.16699 12.3624 7.16699 14.3333V35.8333C7.16699 37.8041 8.77949 39.4166 10.7503 39.4166H32.2503C34.2212 39.4166 35.8337 37.8041 35.8337 35.8333V14.3333C35.8337 12.3624 34.2212 10.7499 32.2503 10.7499ZM21.5003 7.16659C23.4712 7.16659 25.0837 8.77909 25.0837 10.7499H17.917C17.917 8.77909 19.5295 7.16659 21.5003 7.16659ZM32.2503 35.8333H10.7503V14.3333H14.3337V17.9166C14.3337 18.902 15.1399 19.7083 16.1253 19.7083C17.1107 19.7083 17.917 18.902 17.917 17.9166V14.3333H25.0837V17.9166C25.0837 18.902 25.8899 19.7083 26.8753 19.7083C27.8607 19.7083 28.667 18.902 28.667 17.9166V14.3333H32.2503V35.8333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.724daea13d3aacecc379a0ae46ee593b.svg";
export { ForwardRef as ReactComponent };